import { styled } from 'styled-components';

export const StyledWrapper = styled.div`
  position: relative;
  z-index: 1;

  .trends-chart {
    aspect-ratio: 16 / 9;
    height: 370px;
  }
`;

export const StyledAlertCard = styled.div`
  width: 350px;
  height: 200px;
  z-index: 10000;
`;
